import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "react-bootstrap";

const AddWorkflowModal = ({ isAddWorkflowModalOpen, handleAddWorkflow, handleCancelModal }) => {

    const [workflowName, setWorkflowName] = useState('');

    return (
        <Modal
            show={isAddWorkflowModalOpen}
            onHide={handleCancelModal}
            dialogClassName="modal-90w"
            aria-labelledby="contained-modal-title-vcenter"
            className="add-new-taxrule-modal add-order-modals"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Add Workflow
                </Modal.Title>
            </Modal.Header>

            <ModalBody>
            <div className="add-workflow-form">
                <div className="form-group mb-4">
                    <label>Workflow Name</label>
                    <div className="input-group">
                        <input
                            type="text"
                            className="form-control"
                            name="workFlowName"
                            value={workflowName}
                            placeholder="Enter Workflow Name"
                            onChange={(e) => setWorkflowName(e.target.value)}
                        />
                    </div>
                </div>
            </div>        
            </ModalBody>    
            
            <ModalFooter>
                <Button color="secondary" className="cancel-btn" onClick={handleCancelModal}>Cancel</Button>{' '}
                <Button color="primary" className="btn btn-save" onClick={() => handleAddWorkflow(workflowName)}>Add</Button>
            </ModalFooter>    
        </Modal>
    )
}

export default AddWorkflowModal;